export default "__VITE_PUBLIC_ASSET__3d2c3c38__"